module.exports = "varying highp vec4 _picking_color_pass_;"